/**
 * Objectives List Redirect Component
 *
 * Redirects /okr/objectives to /okr with a toast notification.
 * Users must now select a cycle before viewing objectives.
 */

import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useToast } from '@/hooks/useToast';

export default function ObjectivesRedirect() {
  const toast = useToast();

  useEffect(() => {
    toast.info('Agora é necessário selecionar um ciclo primeiro.');
  }, [toast]);

  return <Navigate to="/okr" replace />;
}
